import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


class FormCheckbox extends React.Component {
  constructor(props) {
    super(props);
    const { isChecked } = props;
    this.state = {
      isChecked,
    };
  }

  componentDidUpdate(prevProps) {
    const { isChecked: prevIsChecked } = prevProps;
    const { isChecked } = this.props;
    if (prevIsChecked !== isChecked) {
      this.setState({ isChecked });
    }
  }

  componentWillMount() {
    const {
      isRequired, isRequiredError, name,
      onInit, onUpdate,
    } = this.props;
    const { isChecked } = this.state;
    const updateParams = {
      [name]: {
        isRequired,
        isRequiredError,
        value: isChecked,
      },
    };

    if (onInit) {
      onInit(updateParams);
    }

    if (onUpdate) {
      onUpdate(updateParams);
    }
  }

  handleChange() {
    const { isChecked } = this.state;
    const {
      isRequired, isRequiredError, name,
      onChange, onUpdate,
    } = this.props;
    const updateParams = {
      [name]: {
        isRequired,
        isRequiredError,
        value: !isChecked,
      },
    };

    if (onChange) {
      onChange(updateParams);
    }

    if (onUpdate) {
      onUpdate(updateParams);
    }

    this.setState({ isChecked: !isChecked });
  }
  render() {
    const { isChecked } = this.state;
    const { extraClassName, name, label } = this.props;
    return (
      <div className={classNames(styles.checkBoxContainer, extraClassName)}>
        <div className={classNames(styles.checkBoxInput, isChecked && styles.isChecked)}>
          <input
            id={`id_${name}`}
            name={name}
            type="checkbox"
            checked={isChecked}
            className={classNames(styles.checkBox, 'jest-slider-checkbox')}
            onChange={() => { this.handleChange(); }} />
        </div>
        {label &&
          <label className={styles.label} htmlFor={`id_${name}`} dangerouslySetInnerHTML={{ __html: label }} />
        }
      </div>
    );
  }
};

FormCheckbox.defaultProps = {
  isChecked: false,
};

FormCheckbox.propTypes = {
  isChecked: PropTypes.bool,
};

export default FormCheckbox;
